var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,15.6126761 C22.391732,15.6126761 28,20.3483263 28,25.1220657 C28,27.0043117 26.7218677,27.9368185 24.3100033,27.9968942 L24.0564617,28 L6.95796738,28 C4.37000884,28 3,27.0713266 3,25.1220657 C3,20.3524897 8.61828761,15.6126761 15.5,15.6126761 Z M15.5,17.6126761 C9.65467103,17.6126761 5,21.539544 5,25.1220657 C5,25.7088602 5.28932197,25.9560054 6.56579632,25.9945502 L6.95796738,26 L24.0564617,26 L24.4455087,25.9945521 C25.7119131,25.9560202 26,25.7089449 26,25.1220657 C26,21.5349114 21.3550313,17.6126761 15.5,17.6126761 Z M15.5144291,1 C19.0789336,1 21.9830615,4.10186005 21.9830615,7.98591549 C21.9830615,11.9270827 19.0812851,15.133216 15.5144291,15.133216 C11.9458611,15.133216 9.04786221,11.9418941 9.03136763,8.01525822 C9.03136763,4.14442877 11.9506114,1 15.5144291,1 Z M15.5144291,3 C13.0897501,3 11.0313588,5.21716224 11.0313588,8.01105531 C11.0433938,10.8745234 13.0944839,13.133216 15.5144291,13.133216 C17.9297571,13.133216 19.9830615,10.8645479 19.9830615,7.98591549 C19.9830615,5.17805895 17.9438458,3 15.5144291,3 Z",
    id: "account",
    fill: "#626469",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon_account.6862ea3c7dd0e6e97087b625dfb3d528.svg";
export { ForwardRef as ReactComponent };